import React from 'react';

const About = (props) => {
  const { history } = props;
  return (
    <div>
      <section className="banner gen-banner">
        <div className="container">
          <div className="row  ">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h1>About iCause</h1>
              <p className="">We know you’re as passionate as us about making a difference! If you’re looking for inspiration for your next fundraising campaign, browse our fundraising ideas below.</p>

            </div>
          </div>
        </div>
      </section>
      <section className='my-5 about-sec-2'>
        <div className='container'>
          <div className='row align-items-center  '>
            <div className='col-lg-7 col-md-6 col-sm-12 custom-text-width'>
              <h3 className="main-heading mt-4 mb-4 mt-md-0">Our Mission</h3>
              <p className="">Australia has shown over and over again that we’re a giving nation; from supporting a local club to inspiring global change, we know that it all starts with the first step. We’ve created iCause to give every Australian the chance to help. Through us, you can create a campaign, share your message.</p>
              <p className="">Raise funds and donate to a cause you care about.</p>
              <button type="button" className="btn btn-outline-dark mt-3">LEARN MORE</button>
            </div>
            <div className='col-lg-5 col-md-6 col-sm-12 text-center'>
              <div className="img-wrap">
                <img src="/images/our-mission.PNG" className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="honestly about-sec-3">
        <div className="container">
          <div className="row  ">
            <div className="col-lg-3 col-md-4 col-sm-12 mx-auto">
              <div className="img-wrap">
                <img src="/images/our-mission-2.PNG" className="img-fluid w-100" alt="" />
              </div>
            </div>
            <div className="col-lg-9 col-md-8 col-sm-12">
              <div className="honestly-content custom-text-width">
                <h3 className="main-heading mt-4 mb-0 mt-md-0 text-white">Honestly, iCause Saved<br></br> myBrother Life !</h3>
                <p className="text-white">by Mike Jackson</p>
                <p className="text-white">Australia has shown over and over again that we’re a giving nation; from supporting   a local club to inspiring global change, we know that it all starts with the first step. We’ve created iCause to give every Australian the chance to help.</p>
                <ul  >
                  <li ><span>164</span><br></br> Participants </li>
                  <li><span>29k</span><br></br>Money Collected</li>
                  <li><span>30k</span><br></br>Our Goal</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='my-5 about-sec-5'>
        <div className='container'>
          <div className='row align-items-center  '>
            <div className='col-lg-5 col-md-6 col-sm-12 text-center order-md-1 order-sm-2'>
              <div className="img-wrap">
                <img src="/images/our-mission-3.PNG" className="img-fluid" alt="" />
              </div>
            </div>
            <div className='col-lg-7 col-md-6 col-sm-12 custom-text-width order-md-2 order-sm-1'>
              <h3 className="main-heading mt-4 mb-4 mt-md-0">Our Story</h3>
              <p className="">We know that with the best of intentions, it’s not always possible to give as much as you’d like. That’s why we’ve created a unique way to donate. Not only can you donate directly to your chosen cause, but you can also choose to use your utility bill to donate – it’s easy to do and you might make a saving for yourself in the process. Find out how you can donate with your bill here.</p>

              <button type="button" className="btn btn-outline-dark mt-3">LEARN MORE</button>
            </div>

          </div>
        </div>
      </section>
      <section className='my-5 about-sec-6'>
        <div className="wraper text-center So-Far">
          <div className='container'>
            <div className='row align-items-center  '>
              <div className='col-lg-7 col-md-6 col-sm-12 custom-text-width '>
                <h3 className="main-heading mt-4 mb-4 mt-md-0">So Far...</h3>
                <p className="mx-auto">We know that with the best of intentions, it’s not always possible to give as much as you’d like. That’s why we’ve created a unique way to donate. Not only can you donate directly to your chosen cause, but you can also choose to use your utility bill to donate – it’s easy to do and you might make a saving for yourself in the process. Find out how you can donate with your bill here.</p>
                <ul className="mx-auto text-dark mb-3"  >
                  <li ><span>$ 1.3 million</span><br></br> Donations </li>
                  <li><span>32,100.00</span><br></br>Lives Saved</li>
                  <li><span>3.5 millions</span><br></br>Participants</li>
                </ul>

                <button onClick={() => history.push('/auth/login')} type="button" className="btn btn-outline-dark mt-2 ">Donate now</button>
                <button onClick={() => history.push('/starting_fund')} type="button" className="btn btn-success  ml-2 mt-2  ">Start fundraising</button>

              </div>
              <div className='col-lg-5 col-md-6 col-sm-12 text-center'>
                <div className="img-wrap">
                  <img src="/images/our-mission-4.PNG" className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="client-logo py-5">
        <div className="container">
          <ul className="d-flex justify-content-between flex-wrap">
            <li><img src="/images/logo-1.PNG" className="img-fluid" alt="" /></li>
            <li><img src="/images/logo-2.PNG" className="img-fluid" alt="" /></li>
            <li><img src="/images/logo-3.PNG" className="img-fluid" alt="" /></li>
            <li><img src="/images/logo3.PNG" className="img-fluid" alt="" /></li>
            <li><img src="/images/logo-1.PNG" className="img-fluid" alt="" /></li>
           </ul>
        </div>
     </div>
    </div>
  );
}

export default About;
